<div class="container content" style="padding-top: 8rem; padding-bottom: 4rem;">
  <h1>Politique de confidentialité</h1>
  <p>Dernière mise à jour : <time id="privacyUpdate">{{ currentDate }}</time></p>

  <h2>Application Harmonia</h2>
  <p>L'application mobile Harmonia fonctionne localement sur votre appareil. Elle ne collecte, ne stocke, ne transmet et ne partage aucune donnée personnelle ou sensible de l'utilisateur. Aucune création de compte n'est requise. Pour toute question relative à l'application, contactez-nous directement à l'adresse : <a href="mailto:contact@mesh-box.fr">contact@mesh-box.fr</a>.</p>

  <h2>1. Responsable du traitement</h2>
  <p>Mesh Box — Contact : <a href="mailto:contact@mesh-box.fr">contact@mesh-box.fr</a> ou réseaux professionnels indiqués sur le site.</p>

  <h2>2. Données collectées</h2>
  <ul>
    <li>Formulaire statique : les informations saisies ne sont pas envoyées automatiquement.</li>
    <li>Mesure d’audience respectueuse (le cas échéant) : agrégée et anonyme.</li>
  </ul>

  <h2>3. Finalités</h2>
  <p>Répondre à vos demandes, améliorer le site et présenter des services professionnels.</p>

  <h2>4. Conservation</h2>
  <p>Les données ne sont conservées que le temps nécessaire à la finalité annoncée.</p>

  <h2>5. Droits des personnes</h2>
  <p>Vous pouvez demander l’accès, la rectification ou la suppression de vos données en me contactant via LinkedIn.</p>

  <h2>6. Sous‑traitants et transferts</h2>
  <p>Le site peut utiliser des services d’hébergement et de diffusion de contenu. Aucun transfert non nécessaire n’est réalisé.</p>

  <h2>7. Cookies</h2>
  <p>Par défaut, aucun cookie marketing. Si un outil de mesure d’audience est activé, il sera configuré sans suivi individuel.</p>

  <h2>8. Sécurité</h2>
  <p>Bonnes pratiques de sécurité et mises à jour régulières appliquées à l’hébergement du site.</p>

  <h2>9. Contact</h2>
  <p>Pour toute question, contactez Mesh Box : <a href="mailto:contact@mesh-box.fr">contact@mesh-box.fr</a>.</p>
</div>
